import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store'

Vue.use(VueRouter);

const routes = [

		 {
		 	path: '/',
		 	redirect: '/home'
		 },

		{
			path: '/login',
			name: 'login',
			exact: true,
			component: () => import('./pages/Login.vue'),
			meta: {
				publica: true
			}
		},

		{
			path: '/home',
			name: 'home',
			exact: true,
			component: () => import('./pages/Home.vue')

		},

		{
			path: '/admin/login-adm',
			name: 'login.adm',
			exact: true,
			component: () => import('./pages/admin/LoginAdm.vue'),
			meta: {
				publica: true
			}
		},

		{
			path: '/cadastre-se',
			name: 'novo.usuario',
			exact: true,
			component: () => import('./pages/NovoUsuario.vue'),
			meta: {
				publica: true
			}
		},

		{
			path: '/esqueci-senha',
			name: 'esqueci.senha',
			exact: true,
			component: () => import('./pages/EsqueciSenha.vue'),
			meta: {
				publica: true
			}
		},

		{
			path: '/confirmacao/:token',
			name: 'confirmacao.email',
			exact: true,
			component: () => import('./pages/ConfirmacaoEmail.vue'),
			meta: {
				publica: true
			}
		},

		{
			path: '/meu-cadastro',
			name: 'meu.cadastro',
			exact: true,
			component: () => import('./pages/MeuCadastro.vue')
		},

		{
			path: '/atualizar-meu-cadastro',
			name: 'atualizar.meu.cadastro',
			component: () => import('./pages/AtualizarMeuCadastro.vue')
		},

		{
			path: '/inscricao',
			name: 'inscricao',
			exact: true,
			component: () => import('./pages/Inscricao.vue')
		},

		{
			path: '/minha-inscricao',
			name: 'minha.inscricao',
			component: () => import('./pages/MinhaInscricao.vue')
		},

		{
			path: '/alterar-senha',
			name: 'alterar.senha',
			exact: true,
			component: () => import('./pages/AlterarSenha.vue')
		},

		{
			path: '/admin/inscricoes',
			name: 'inscricoes',
			exact: true,
			component: () => import('./pages/admin/Inscricoes.vue')
		},

		{
			path: '/admin/areas',
			name: 'areas',
			exact: true,
			component: () => import('./pages/admin/Areas.vue')
		},

		{
			path: '/admin/processos-seletivos',
			name: 'processos.seletivos',
			exact: true,
			caminho: '/admin/processos seletivos',
			component: () => import('./pages/admin/ProcessosSeletivos.vue')
		},

		{
			path: '/admin/candidatos',
			name: 'candidatos',
			exact: true,
			component: () => import('./pages/admin/Candidatos.vue')
		},

		{
			path: '/admin/notas',
			name: 'notas',
			exact: true,
			component: () => import('./pages/admin/Notas.vue')
		},

		{
			path: '/processo-em-andamento',
			name: 'processo.em.andamento',
			exact: true,
			component: () => import('./pages/ProcessoEmAndamento.vue')
		},

		{
			path: '/admin/distribuicao',
			name: 'distribuicao',
			exact: true,
			component: () => import('./pages/admin/Distribuicao.vue')
		},
		{
			path: '/admin/cartao',
			name: 'cartao',
			exact: true,
			component: () => import('./pages/admin/CartaoLiberar.vue')
		},
		{
			path: '/admin/resultado',
			name: 'resultado',
			exact: true,
			component: () => import('./pages/admin/GerarResultado.vue')
		},
		{
			path: '/admin/resultadoDocumental',
			name: 'resultadoDocumental',
			exact: true,
			component: () => import('./pages/admin/GerarResultadoDocumental.vue')
		}

	]

	const router = new VueRouter({
		routes
	})

	//Exige o login para todas as paginas
	router.beforeEach((routeTo, routeFrom, next) => {


	if(!store.state.token ){
		store.state.token = localStorage.getItem('token');
		store.state.usuario = localStorage.getItem('usuario');
        store.state.perfil = localStorage.getItem('perfil');
        store.state.nome = localStorage.getItem('nome');
		store.state.username = localStorage.getItem('username');
		store.state.processoSelecionado = JSON.parse(localStorage.getItem('processoSelecionado'));
	}



		if(!routeTo.meta.publica && !store.state.token) {
			return next({ path: '/login' })
		}
		next()
	})

export default router